export interface TaskInsight {
    actionType: ActionType;
    sourceMailId: string;
    sourceMailConversationId: string;
    taskId: string;
}

export interface PotentialAction {
    name: PotentialActionType;
    text: string;
    actionPayload: string;
}

export const enum ActionType {
    /// <summary>
    /// Unknown action.
    /// </summary>
    Unknown = 'Unknown',
    /// <summary>
    /// Action representing a commitment.
    /// </summary>
    Commitment = 'Commitment',
    /// <summary>
    /// Action representing a request.
    /// </summary>
    Request = 'Request',
    /// <summary>
    /// Action representing a follow-up.
    /// </summary>
    FollowUp = 'FollowUp',
    /// <summary>
    /// Action representing a follow-up action request.
    /// </summary>
    FollowUpActionRequest = 'FollowUpActionRequest',
    /// <summary>
    /// Action representing a follow-up reply request.
    /// </summary>
    FollowUpReplyRequest = 'FollowUpReplyRequest',
    /// <summary>
    /// Action representing an assigned request.
    /// </summary>
    AssignedRequest = 'AssignedRequest'
}

export const enum InsightName {
    FollowUpsInsight = 0
}

export enum PotentialActionType {
    MarkTaskAsDone = 'MarkTaskAsDone',
    MarkAsNotATask = 'MarkAsNotATask',
    PromoteTask = 'PromoteTask',
    DismissAction = 'DismissAction',
    UndoTask = 'UndoTask' // TODO:Check if this exists today in response
}

export interface User {
    DisplayName: string;
    email: string;
}
